export const baseFrameRate = 30.0;
export const uvRotateTileHeight = 64;
export const moveableScrollAnimTileHeight = 128;

export const ObjectID: { [name: string]: number } = {
    "Lara":             0,
    "LaraJoints":       9,
    "LaraBraid":        -1,
};
